module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tren-crs"
    }
  }, [_c('h3', [_vm._v("Agama")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "Right"
    },
    on: {
      "click": function($event) {
        _vm.handleViewAll()
      }
    }
  }, [_c('a', [_vm._v("View All...")])]), _vm._v(" "), _c('div', {
    staticClass: "crs-swiper-container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.courseSwiper
    }
  }, _vm._l((_vm.CurrentContent), function(m, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "card card-1",
      attrs: {
        "id": "course-swiper"
      }
    }, [(index < _vm.$store.state.FixedShow) ? _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "src": _vm.$store.state.urlLink + m.bookId + '.png',
        "alt": m.bookName,
        "kappa": m.BookName,
        "id": m.bookId
      },
      on: {
        "click": _vm.handleBook
      }
    })]) : _c('div', [_c('img', {
      staticClass: "swiper-lazy pointer",
      attrs: {
        "id": "ViewMore",
        "src": "images/View More(N).png"
      },
      on: {
        "click": function($event) {
          _vm.handleViewAll()
        }
      }
    })])])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a854ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/landingSwiper/No3_Agama.vue
// module id = 1687
// module chunks = 1